<template>
  <div>
    <div class="logo">
      <div>
        <img :src="logo" alt="" style="width: 560px;height: 59px;">
      </div>
      <div class="login">
        <div v-if="username">
          <span style="color:rgb(103, 124, 72) ">{{ username }}</span>
          <span @click.stop="updatePassword">修改密码</span>
          <span @click.stop="exit">退出</span>
        </div>
        <div v-else>
          <span style="color: rgb(103, 124, 72)" @click="login">去登录</span>
          <span style="color: #000000" @click="register">注册</span>
        </div>
      </div>
    </div>
    <div class="swiper-container">
      <el-carousel class="mine-carousel" height="250px">
        <el-carousel-item v-for="item in imageList" :key="item">
          <img style="height: 100%;width: 100%" :src="item" alt="" srcset="">
        </el-carousel-item>
      </el-carousel>
    </div>

    <el-dialog :visible.sync="visible" title="修改密码" width="500px" @open="init">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item prop="old_password" label="旧密码">
          <el-input type="password" v-model="form.old_password"/>
        </el-form-item>
        <el-form-item prop="new_password" label="新密码">
          <el-input type="password" v-model="form.new_password"/>
        </el-form-item>
        <el-form-item prop="new_confirm_password" label="确认密码">
          <el-input type="password" v-model="form.new_confirm_password"/>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="savePassword">确认</el-button>
        <el-button size="small" @click="visible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import logo from '@/assets/logo.jpg'
import slider1 from '@/assets/images/slider1.jpg'

export default {
  name: 'TopSlider',
  data() {
    return {
      logo,
      imageList: [
        slider1
      ],
      username: localStorage.getItem("username"),
      visible: false,
      form: {
        old_password: undefined,
        new_password: undefined,
        new_confirm_password: undefined,
      },
      rules: {
        old_password: [
          {required: true, trigger: "blur", message: "旧密码不能为空"},
        ],
        new_password: [
          {required: true, trigger: "blur", message: "新密码不能为空"},
        ],
        new_confirm_password: [
          {required: true, trigger: "blur", message: "确认密码不能为空"},
        ]
      }
    }
  },
  methods: {
    exit() {
      this.username = null
      localStorage.removeItem('username');
      localStorage.removeItem('token');
    },
    updatePassword() {
      this.visible = true
    },
    login() {
      this.$router.push({path: '/login', query: {third: 1}})
    },
    register() {
      this.$router.push({path: '/register'})
    },
    init() {
      this.form = {
        old_password: undefined,
        new_password: undefined,
        new_confirm_password: undefined,
      }
    },
    savePassword() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.new_password !== this.form.new_confirm_password) {
            this.$message.error("新密码输入不一致，请确认")
            return
          }
          this.$request.post('/com/jiao/updatePassword', {...this.form})
              .then(ret => {
                if (ret.code === 200) {
                  this.$message.success("修改成功")
                  this.visible = false
                }
              })
        }
      })
    }
  }
}
</script>
<style scoped>
.logo {
  text-align: left;
  display: flex;
  justify-content: space-between;
}

.login {
  display: flex;
  align-items: end;
  padding-bottom: 10px;
}

.login span {
  margin-left: 10px;
  font-size: 14px;
  text-decoration: underline;
}

.swiper-container {
  width: 100%;
}
</style>
<style>
.mine-carousel {
  height: 100%;
}

.mine-carousel .el-carousel__container {
  height: 100%;
}
</style>
